(ns frontend.ui.component.lp-portal.report.body.invest-europe.holding.exit.controller
  (:require
   [frontend.ui.component.lp-portal.report.body.invest-europe.holding.controller :refer [block-table-raw-data->editable-data
                                                                                         invest-europe-editable-data->raw-data
                                                                                         invest-europe-table-raw-data->editable-data]]
   [frontend.ui.component.lp-portal.report.component.multi-chart.controller :as multi-controller]
   [frontend.ui.component.lp-portal.report.component.overview-figures.controller :as ov-ctl]
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]))

(defn ->ui-data
  [{:keys [dynamic-data report-data] :as props}]
  {:holding-name           (get-in report-data [:holding-name])
   :reference-date         (get-in report-data [:reference-date])
   :report-id              (:report-id props)
   :overview               {:case-overview   (report-ctl/rich-content
                                              props
                                              :case-overview-exit-text)
                            :investment-info (->>
                                              (report-ctl/with-footnote
                                                props
                                                :investment-info-exit-footnotes
                                                (:investment-info-exit report-data))
                                              (report-ctl/with-editable-tables (merge {:fixed-columns? true
                                                                                       :fixed-labels? true} props)
                                                :investment-info-exit
                                                block-table-raw-data->editable-data
                                                invest-europe-editable-data->raw-data))}
   :highlight-figures-exit (report-ctl/with-footnote
                             props
                             :highlight-figures-exit-footnotes
                             (ov-ctl/figures (get-in report-data [:highlight-figures-exit])))
   :headcount-exit (->>
                    (get-in report-data
                            [:headcount-exit])
                    (report-ctl/with-footnote
                      props
                      :headcount-exit-footnotes)
                    (report-ctl/with-editable-charts
                      (merge {:multi-chart? true} props)
                      :headcount-exit
                      multi-controller/multi-chart-ctl
                      multi-controller/config->editable-data
                      multi-controller/editable-data->raw-data))
   :equity-grants-loans-exit (->>
                              (report-ctl/with-footnote
                                props
                                :equity-grants-loans-exit-footnotes
                                (:equity-grants-loans-exit report-data))
                              (report-ctl/with-editable-tables props :equity-grants-loans-exit
                                invest-europe-table-raw-data->editable-data
                                invest-europe-editable-data->raw-data))
   :financial-performance-exit (->>
                                (get-in report-data
                                        [:financial-performance-exit])
                                (report-ctl/with-footnote
                                  props
                                  :financial-performance-exit-footnotes)
                                (report-ctl/with-editable-charts
                                  (merge {:multi-chart? true} props)
                                  :financial-performance-exit
                                  multi-controller/multi-chart-ctl
                                  multi-controller/config->editable-data
                                  multi-controller/editable-data->raw-data))

   :logo-image-1           (report-ctl/image-content
                            props
                            :logo-image-1-footnotes
                            (:logo-image-1 dynamic-data))})
